import { useGetBuyerSuspense } from "@getbread/api-client-buyer-v2";
import { useAuthentication } from "../components/AuthenticationProvider";

export const useCurrentBuyer = () => {
	const { buyerId } = useAuthentication();
	return useGetBuyerSuspense(buyerId).data.data;
};
